import { getApiUrl } from "@/config/environment";

export function apiFetch(path: string, init: RequestInit = {}) {
  return fetch(getApiUrl(path), {
    ...init,
    credentials: "include",
    headers: {
      ...(init.headers || {}),
    },
  });
}
